import { useState } from 'react'
import { Button, Spin } from 'antd'

import { Document, Page } from './reactPdf'
import { rejectPasswordProtectedPdf } from './pdfPassword'

const PdfError = ({ src, message }: { src: string; message: string }) => (
  <div style={{ textAlign: 'center', padding: 24 }}>
    <div style={{ marginBottom: 8 }}>{message}</div>
    <Button
      type="link"
      onClick={(e) => {
        e.stopPropagation()
        window.open(src, '_blank')
      }}
    >
      Open in new tab
    </Button>
  </div>
)

type PdfCanvasProps = {
  src: string
  pageNumber: number
  height: number
  zoomScale?: number
  onLoad?: (numPages: number) => void
}

export const PdfCanvas = ({ src, pageNumber, height, zoomScale = 1, onLoad }: PdfCanvasProps) => {
  // Keyed by src so selecting another document does not inherit the previous verdict.
  const [lockedSrc, setLockedSrc] = useState<string | null>(null)

  return (
    <Document
      file={src}
      loading={<Spin />}
      error={
        <PdfError
          src={src}
          message={
            lockedSrc === src
              ? 'This PDF is password-protected and cannot be previewed'
              : 'Failed to render PDF'
          }
        />
      }
      onPassword={(callback) => {
        setLockedSrc(src)
        rejectPasswordProtectedPdf(callback)
      }}
      onLoadSuccess={({ numPages }) => onLoad?.(numPages)}
    >
      <div style={{ boxShadow: '0 2px 12px rgba(0, 0, 0, 0.25)', lineHeight: 0 }}>
        <Page
          pageNumber={pageNumber}
          height={height}
          // The viewer zoom is a CSS transform. Render extra PDF pixels first,
          // otherwise zooming magnifies an already rasterized canvas.
          devicePixelRatio={Math.max(window.devicePixelRatio || 1, zoomScale)}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
      </div>
    </Document>
  )
}
